import React from 'react';
import {Field} from 'redux-form';
import {Form, Row, Col} from 'react-bootstrap';
import Button from '@material-ui/core/Button';
import * as fields from 'components/common/fields';
import * as validators from 'utils/validators';
import {makeForm} from 'utils/common';

class ResetForgotPasswordForm extends React.Component {
  render() {
    const {handleSubmit, pristine, submitting} = this.props;
    return (
      <Form onSubmit={handleSubmit}>
        <Row>
          <Col md={6}>
            <Field
              name="password"
              label="Password"
              component={fields.Input}
              required
              type="password"
              validate={[validators.isRequired]}
            />
          </Col>
          <Col md={6}>
            <Field
              name="confirmPassword"
              label="Confirm Password"
              component={fields.Input}
              required
              type="password"
              validate={[validators.isRequired, validators.isConfirmPasswordMatch]}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Button type="submit" variant="contained" color="primary" fullWidth disabled={pristine || submitting}>
              Submit
            </Button>
          </Col>
        </Row>
      </Form>
    );
  }
}

export default makeForm(ResetForgotPasswordForm, 'ResetForgotPasswordForm', null, null);
